module.exports = __webpack_public_path__ + "img/flag.59befc57.svg";